<template>
  <div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.BANK_NAME }}</p>
      <p class="min-h-6">{{ bankDetail?.name }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.CODE_OF_BANK_REQUISITE }}</p>
      <p class="min-h-6">{{ bankDetail?.cardNumber }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.INN_PIN }}</p>
      <p class="min-h-6">{{ bankDetail?.inn }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.BIK }}</p>
      <p class="min-h-6">{{ bankDetail?.bik }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.TAX_AUTHORITY_CODE }}</p>
      <p class="min-h-6">{{ bankDetail?.taxAuthorityCode }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.TAX_AUTHORITY_DISTRICT }}</p>
      <p class="min-h-6">{{ bankDetail?.taxAuthorityDistrict }}</p>
      <hr />
    </div>
<!--    <div v-if="userType === userTypesGetValue('LEGAL_ENTITY')" class="my-5">-->
<!--      <p class="text-xs text-gray-500">{{ $lang.app.UGNS_KKN }} :</p>-->
<!--      <p class="min-h-6">{{ bankDetail?.kkn }}</p>-->
<!--      <hr />-->
<!--    </div>-->
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ userType === userTypesGetValue('LEGAL_ENTITY')
          ? $lang.app.MAIN_BANK_ACCOUNT : $lang.app.ACCOUNT_NUMBER }}</p>
      <p class="min-h-6">{{ bankDetail?.paymentAccount }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.ATTACH_CONFIRMATION_DOCUMENT }}</p>
      <p class="min-h-6 cursor-pointer text-blue-500 font-medium"
         @click="$emitter.emit('open-pdf-file-modal', bankDetail?.files)">
        {{ bankDetail?.files?.filename }}
      </p>
      <hr />
    </div>
  </div>
</template>
<script>
import {getValueByKey as userTypesGetValue} from "../../../../helpers/constants/userTypes";

export default {
  props: {
    userType: Number,
    bankDetail: Object,
  },
  methods: {
    userTypesGetValue
  }
}
</script>